import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=0f74f3dc&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=0f74f3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f74f3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0f74f3dc', component.options)
    } else {
      api.reload('0f74f3dc', component.options)
    }
    module.hot.accept("./DropdownButton.vue?vue&type=template&id=0f74f3dc&scoped=true&", function () {
      api.rerender('0f74f3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/DropdownButton.vue"
export default component.exports